import React from 'react';
import { Tag, X } from 'lucide-react';
import { useOrders } from '../contexts/OrderContext';
import { COMPANIES } from '../utils/companyData';
interface CompanyFilterSidebarProps {
  onCompanySelect?: (company: string) => void;
  selectedCompany?: string;
}
export function CompanyFilterSidebar({
  onCompanySelect,
  selectedCompany
}: CompanyFilterSidebarProps) {
  const {
    orders
  } = useOrders();
  const getCompanyStats = (companyName: string) => {
    const companyOrders = orders.filter(o => o.company === companyName && o.status !== 'Cancelado' && o.status !== 'Entregado');
    const pending = companyOrders.filter(o => o.labelStatus === 'Pendiente').length;
    const total = companyOrders.length;
    return {
      pending,
      total
    };
  };
  // Only show companies that have orders
  const companiesWithOrders = COMPANIES.filter(company => {
    const stats = getCompanyStats(company.name);
    return stats.total > 0;
  });
  const handleClearFilters = () => {
    if (onCompanySelect) {
      onCompanySelect('');
    }
  };
  return <div className="h-full" data-id="element-89">
      <div className="flex justify-between items-center mb-6" data-id="element-90">
        <h3 className="text-sm font-bold text-gray-900 dark:text-white tracking-wide" data-id="element-91">Etiquetas por Empresa
 </h3>
        <div className="flex space-x-2" data-id="element-92">
          
        </div>
      </div>

      <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-100 dark:border-gray-800" data-id="element-93">
        <span onClick={handleClearFilters} className="text-xs text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white cursor-pointer transition-colors font-medium" data-id="element-94">
          Limpiar filtros
        </span>
        
      </div>

      <div className="space-y-1 pr-2" data-id="element-95">
        {companiesWithOrders.map(company => {
        const stats = getCompanyStats(company.name);
        const isSelected = selectedCompany === company.name;
        return <label key={company.id} className={`flex items-start cursor-pointer group p-3 rounded-lg transition-all ${isSelected ? 'bg-black dark:bg-white shadow-lg' : 'hover:bg-gray-50 dark:hover:bg-gray-800'}`} onClick={() => onCompanySelect && onCompanySelect(company.name)} data-id="element-96">
              <div className="flex items-center h-5" data-id="element-97">
                <input type="radio" name="company" checked={isSelected} onChange={() => {}} className="h-4 w-4 rounded-full border-gray-300 dark:border-gray-600 text-black dark:text-white focus:ring-black dark:focus:ring-white" data-id="element-98" />
              </div>
              <div className="ml-3 flex-1" data-id="element-99">
                <div className="flex justify-between items-center mb-1" data-id="element-100">
                  <span className={`text-sm font-semibold transition-colors ${isSelected ? 'text-white dark:text-black' : 'text-gray-900 dark:text-white group-hover:text-gray-900'}`} data-id="element-101">
                    {company.name}
                  </span>
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${isSelected ? 'bg-white/20 text-white dark:bg-black/20 dark:text-black' : 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300'}`} data-id="element-102">
                    {stats.total}
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-103">
                  <span className={`text-xs ${isSelected ? 'text-white/70 dark:text-black/70' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-104">
                    {stats.pending} pendiente{stats.pending !== 1 ? 's' : ''}
                  </span>
                </div>
              </div>
            </label>;
      })}
      </div>

      {companiesWithOrders.length === 0 && <div className="mt-8 text-center text-xs text-gray-400 dark:text-gray-500" data-id="element-105">
          <p data-id="element-106">No hay pedidos activos.</p>
          <p className="mt-1" data-id="element-107">Las empresas aparecerán cuando tengan pedidos.</p>
        </div>}
    </div>;
}